import Node from '../node.js';
import { PARAM_TYPE } from '../connector.js';

export default class NodeCreateCurve extends Node
{
	constructor(pParent)
	{
		super(pParent);	
		this.addInput(PARAM_TYPE.SPLINE, 'spline', null, { isConnectorHidden: true });
		this.addOutput(PARAM_TYPE.SPLINE, 'spline');
	}
	
	getType()
	{
		return 'createCurve';
	}
	
	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		return inputValues['spline'];
	}
}
